import { render, staticRenderFns } from "./EmployeePositionEditor.vue?vue&type=template&id=65124382&scoped=true&"
import script from "./EmployeePositionEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeePositionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65124382",
  null
  
)

export default component.exports